import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Drawer from '../../Utils/Drawer';

export default function BtnPrimary() {

  const [drawer, setDrawer] = useState(false);

  const listenChild = (valueChild) => {
    setDrawer(valueChild)
  }

  return (
    <>
      <Drawer state={drawer} listenChild={listenChild} />

      <a
        href="https://firebasestorage.googleapis.com/v0/b/arnaud-desportes-portfolio.appspot.com/o/CV%2FCV-DEVELOPPEUR-FRONT-END-REACT-ARNAUD-DESPORTES.pdf?alt=media&token=0d47a67c-777f-4ad6-a36a-c24f2498b0f2"
        target="_blank"
        rel="noreferrer"
        className="capitalize hidden lg:block items-end bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-sm focus:outline-none transition duration-200 ease-in-out lg:px-7 px-4 py-2 md:py-2 text-center"
      >
        <span className="pl-2"><FontAwesomeIcon icon="file-download" className="mr-2 " /></span>
        CV
      </a>

      <a
        href="https://firebasestorage.googleapis.com/v0/b/arnaud-desportes-portfolio.appspot.com/o/CV%2FCV-DEVELOPPEUR-FRONT-END-REACT-ARNAUD-DESPORTES.pdf?alt=media&token=0d47a67c-777f-4ad6-a36a-c24f2498b0f2"
        target="_blank"
        rel="noreferrer"
        className="hidden md:block lg:hidden items-end bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-full focus:outline-none transition duration-200 ease-in-out px-3 py-2 md:py-2"
      >
          
      </a>

      <button onClick={() => setDrawer(!drawer)} className="xs:block md:hidden items-end bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-full focus:outline-none transition duration-200 ease-in-out px-3 py-2 md:py-2">
        <FontAwesomeIcon icon="hamburger" />
      </button>
    </>
  );
}